import { IPatient, v2 } from '../../..';

type ContactRecordParts = Pick<
    IPatient,
    | 'addressLine1'
    | 'town'
    | 'postCode'
    | 'addressLine2'
    | 'addressLine3'
    | 'county'
    | 'geocodedAddress'
    | 'contactNumber'
    | 'additionalContactNumbers'
>;

export const contactRecordAdapter = (contactRecords: v2.ContactRecord[]): ContactRecordParts => {
    const address = contactRecords.find(
        (contactRecord) => contactRecord?.contactType === v2.ContactType.ADDRESS,
    );

    const contactNumbers = contactRecords.filter(
        (contactRecord) => contactRecord?.contactType === v2.ContactType.PHONE,
    );

    const result: Partial<IPatient> = {};

    if (address) {
        result.addressLine1 = address.addressLine1 ?? undefined;
        result.town = address.town ?? undefined;
        result.postCode = address.postCode ?? undefined;
        result.addressLine2 = address.addressLine2 ?? undefined;
        result.addressLine3 = address.addressLine3 ?? undefined;
        result.county = address.county ?? undefined;
        result.geocodedAddress = address.geocodedAddress ?? undefined;
    }

    if (contactNumbers?.length) {
        result.contactNumber = contactNumbers[0].phoneNumber ?? undefined;

        const additionalContactNumbers = contactNumbers
            .slice(1)
            .map((contactNumber) => contactNumber.phoneNumber ?? '')
            .filter((str) => str);

        result.additionalContactNumbers = additionalContactNumbers;
    }

    return result;
};
